import React, { useState, useRef, useEffect } from 'react'
import { FaIcon } from '../../App/Components/FaIcon/FaIcon'
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons'
import '../Chat.css'

type ChatInputProps = {
  onSend: (message: string) => void
  disabled: boolean
  placeholder: string
}

const MAX_LENGTH = 200

export const ChatInput: React.FC<ChatInputProps> = ({ onSend, disabled, placeholder }) => {
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const isOverLimit = inputValue.length > MAX_LENGTH
  const isSendDisabled = disabled || isOverLimit

  useEffect(() => {
    if (!disabled && inputRef.current) {
      inputRef.current.focus()
    }
  }, [disabled])

  const handleSend = () => {
    const trimmed = inputValue.trim()
    if (trimmed && !isSendDisabled) {
      onSend(trimmed)
      setInputValue('')
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <div className="chat__input-wrapper">
      <div className={`chat__input-area${isOverLimit ? ' chat__input-area--error' : ''}`}>
        <input
          ref={inputRef}
          type="text"
          className="chat__input"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          data-testid="chat-input"
        />
        <button
          className={`chat__send-button ${isSendDisabled ? 'chat__send-button--disabled' : ''}`}
          onClick={handleSend}
          disabled={isSendDisabled}
          data-testid="chat-send-button"
        >
          <FaIcon icon={faPaperPlane} />
        </button>
      </div>
      {isOverLimit && (
        <p className="chat__input-error" data-testid="chat-input-error">
          {inputValue.length}/{MAX_LENGTH}
        </p>
      )}
    </div>
  )
}
